import { render, staticRenderFns } from "./pendingProducts.vue?vue&type=template&id=894815f6&"
import script from "./pendingProducts.vue?vue&type=script&lang=js&"
export * from "./pendingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports